module.exports = __webpack_public_path__ + "assets/img/KeyReport_002.03034fd9-ps.jpg";